<template>
    <div style="width:100%;float:left;">
      <!-- <div style="width:100%;float:left;">
        <search-orders></search-orders>
      </div> -->
      <div style="width:100%;float:left;">
        <CCard>
          <CCardHeader>
            Open Orders
            <div style="width:100%;float:right;">
              <v-select style="width:200px;float:right;" :options="orderOptions" name="name" v-model="orderOptionSelected"></v-select>
              <!-- <input type="checkbox" v-model="showAll" @change="getOrders()"> Show All (not only open orders)</input> -->
            </div>
            <div style="width:100%;float:right;">
              <div style="width:50%;float:left;text-align:center;">Start Date
                <input type="date" v-model="startDate" style="float:left;" class="form-control" />
              </div>
              <div style="width:50%;float:left;text-align:center;">End Date
                <input type="date" v-model="endDate" style="float:left;" class="form-control" />
              </div>
              <!-- <input type="checkbox" v-model="showAll" @change="getOrders()"> Show All (not only open orders)</input> -->
            </div>
            <div style="width:100%;float:right;margin-top:5px;">
              <!-- <CButton size="sm" color="success" class="float-right mt-1" @click="getOrders()">Search</CButton> -->
              <input type="text" style="width:100%;float:right;" v-model="searchValue" class="form-control" placeholder="Search Style... EX:(X210P)" />
            </div>
            <div style="width:100%;float:right;text-align:center;">
              <CButton size="sm" color="success" class="mt-1" @click="getOrders()">Search</CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <div class="all text-center" v-if="showAll">
              <v-select style="width:200px;float:right;" :options="filterOptions" name="name" v-model="filter"></v-select>
            </div>
            <!-- <h5 style="width:100%;float:left;text-align: center;font-size:13px;">Click on row to go to order</h5> -->
            <div style="width:100%;float:left;text-align: center;">
              <!-- <v-select style="width:500px;margin-left:auto;margin-right:auto;" placeholder="Select Customer" v-if="customerOptions" :options="customerOptions" name="name" label="label" v-model="customerFilter"></v-select> -->
              <CButton size="sm" class="mt-2" color="info" v-if="!downloadLoading" :disabled="selected.length ? false : true" @click="downloadOrders()">Combine & Email Selected PDF Orders (Max 30)</CButton>
            </div>
            <spacer />
            <!-- <div style="width:100%;float:left;" v-if="orders">{{orders.length}} Orders Showing</div> -->
            <div style="width:100%;float:left;" v-if="!loading">
              <!-- <CDataTable v-if="orders"
                :items="orders"
                :fields="fields"
                :items-per-page="15"
                pagination
                column-filter
                sorter
                table-filter
              > -->
              <CDataTable v-if="orders"
              :items="orders"
              :fields="fields"
              :items-per-page="perPage"
              :pagination="true"
              :total-items="totalItems"
              :current-page.sync="currentPage"
              column-filter
              table-filter
              sorter
              @pagination-change="getOrders"
              >
                <template #local_created_at-header>
                    Entered On
                </template>
                <template #order_id-header>
                    Order#
                </template>
                <template #as400_log_number-header>
                    Log#
                </template>
                <template #po_number="{item}">
                  <td>
                    {{ item.po_number }}
                  </td>
                </template>
                <template #date_shipped="{item}">
                  <td>
                    {{ new Date(item.date_shipped).toISOString().slice(0, 10) }}
                  </td>
                </template>
                <template #tracking="{item}">
                  <td>
                    <div style="width:100%;float:left;" v-for="track in trackingItems(item.tracking)">
                      <a class="text-decoration-underline" style="color:blue;cursor:pointer;text-decoration: underline;" @click="goToTracking(track)">{{ track }}</a>
                    </div>
                  </td>
                </template>
                <template #total_dollars="{item}">
                  <td>
                    {{ formatCurrency(item.total_dollars) }}
                  </td>
                </template>
                <template #status="{item}">
                  <td>
                    <CBadge :color="configureColor(item)">{{ item.status }}</CBadge>
                  </td>
                </template>
                <template #show="{item}">
                  <td>
                    <div style="width:100px;">
                      <CButton size="sm" style="float:left;" color="primary" @click="quickView( item )"><CIcon name="cil-fullscreen" /></CButton>
                      <CButton size="sm" style="float:left;" color="success" @click="goToOrder( item )"><CIcon name="cil-arrow-right" /></CButton>
                    </div>
                  </td>
                </template>
              </CDataTable>
              <center>Press Search button to load orders in based on what's filtered...</center>
            </div>
            <small-loader v-else></small-loader>
          </CCardBody>
          </CCard>
        </div>
        <!-- <adobe-pdf-viewer v-if="pdfModal && pdfData" @closed="pdfModal = false, pdfData = null" :order_group="pdfData" pdf_type="either" :allowEdit="false"></adobe-pdf-viewer> -->
        <div v-if="pdfModal">
            <div class="pdf-container">
                <order-history-pdf-viewer v-if="pdfData" :oldOrderItem="pdfData" :oldOrder="true" @closed="pdfModal = false" />
                <p v-else>No PDF data available.</p>
            </div>
        </div>
    </div>
  </template>
  <script>
  import SearchOrders from './../components/search_orders'
  import OrderHistoryPdfViewer from './../components/order_history_pdf_viewer'
  var methods = {}
  
  methods.rowClicked = function (item) {
    this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
  }
  
  methods.quickView = function (item) {
    // var obj = {
    //   as400_log_number: item.log_number
    // }
    this.pdfData = item
    this.pdfModal = true
  }
  
  methods.checkSelected = function (item) {
    if (this.selected.indexOf(item.order_group_id) > -1) {
      return 1
    } else {
      return 0
    }
  }

  methods.trackingItems = function (tracking) {
    // var arr = '1Z76661R0394817371', '1Z76661R0394817372'
    // const inputString = "1Z76661R0394817371, 1Z76661R0394817372";
    const inputString = tracking

    // Use split() to break the string by commas and remove any extra whitespace around the values
    if (inputString) {
      const resultArray = inputString.split(',').map(item => item.trim());
      return resultArray
    } else {
      return ''
    }

    console.log(resultArray);
  }
  
  methods.goToTracking = function (item) {
    var trackingNumber = item
    let carrierUrl;

    // Regex patterns to identify the carrier
    const upsPattern = /^1Z[0-9A-Z]{16}$/i;  // UPS tracking numbers start with '1Z' followed by 16 alphanumeric characters
    const fedexPattern = /^[0-9]{12,14}$/;   // FedEx Ground/Express usually has 12 or 14 numeric digits
    const uspsPattern = /^[0-9]{20,22}$/;    // USPS typically uses 20-22 digit numbers

    if (upsPattern.test(trackingNumber)) {
        // UPS tracking URL
        carrierUrl = `https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${trackingNumber}`;
    } else if (fedexPattern.test(trackingNumber)) {
        // FedEx tracking URL
        carrierUrl = `https://www.fedex.com/apps/fedextrack/?tracknumbers=${trackingNumber}`;
    } else if (uspsPattern.test(trackingNumber)) {
        // USPS tracking URL
        carrierUrl = `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`;
    } else {
        alert("Unknown tracking number format");
        return;
    }

    // Open the tracking URL in a new tab
    window.open(carrierUrl, '_blank');
  }

methods.formatCurrency = function (item) {
  return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(item);
}

  methods.checkAll = function () {
    if (this.selected.length) {
      return 1
    } else {
      return 0
    }
  }
  
  methods.changeSelected = function (item) {
    if (this.selected.indexOf(item.order_group_id) > -1) {
      this.selected.splice(this.selected.indexOf(item.order_group_id), 1)
    } else {
      this.selected.push(item.order_group_id)
    }
  }
  
  methods.selectAll = function () {
    if (this.selected.length) {
      this.selected = []
    } else {
      var arr = []
      this.orders.forEach(function (val) {
        arr.push(val.order_group_id)
      })
      this.selected = arr
    }
  }
  
  methods.downloadOrders = function () {
    this.downloadLoading = true
      const postData = {
        orders: this.selected
      }
      axios.post(this.$apiAdress + '/api/orders/downloadAllOrdersOnPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
        console.log(response)
        this.downloadLoading = false
        window.Swal.fire({
          type: 'success',
          title: 'Success',
          text: 'You will be emailed the orders shortly.'
        })
        this.selected = []
      }).catch(e => {
        console.log(e)
        window.Swal.fire({
          type: 'error',
          title: 'Error!',
          text: 'Something went wrong, please contact acoleman@paifashion.com if it keeps happening.'
        })
      })
  }
  
  methods.getOrders = function () {
    if (this.orderOptionSelected == 'POs Shipped') {
      this.fields = ['order_date', 'so_number', 'log_number', 'po_number', 'units', 'total_dollars', 'exp_ship_date', 'date_shipped', 'status', 'tracking', 'show']
    } else {
      this.fields = ['order_date', 'so_number', 'log_number', 'po_number', 'units', 'total_dollars', 'exp_ship_date', 'status', 'show']
    }
    if ((this.orderOptionSelected == 'Search By Style' && this.searchValue !== '') || this.orderOptionSelected !== 'Search By Style') {
      this.loading = true
      this.orders = null
      const postData = {
        filter: this.filter,
        customer: this.customer_selected,
        showAll: this.showAll,
        option: this.orderOptionSelected,
        searchValue: this.searchValue,
        page: this.page,
        perPage: this.perPage,
        startDate: this.startDate,
        endDate: this.endDate
      }
      console.log('getting rep orders')
      console.log(postData)
      axios.post(this.$apiAdress + '/api/reports/getCustomerOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
        console.log(response)
        // this.orders = response.data
        var arr = []
        // response.data.forEach(function (val) {
        //   var obj = {}
        //   for (var key in val) {
        //     obj[key] = val[key]
        //   }
        //   // obj.po_number = val.order.po_number
        //   obj.customer_name = val.order.customer_info.customer_name
        //   obj.checked = 0
        //   // obj.rep_name = val.order.rep.name
        //   arr.push(obj)
        // })
        this.orders = response.data.items
        var that = this
        this.orders = this.orders.map(order => ({
          ...order,
          units: parseInt(order.units), // Ensure price is a number
          total_dollars: parseFloat(order.total_dollars, 10), // Ensure order_id is an integer
          order_date: that.formatDate(new Date(order.order_date)), // Ensure order_date is a Date object
          exp_ship_date: that.formatDate(new Date(order.exp_ship_date)),
        }));
        this.selected = []
        this.loading = false
        this.$emit('orders-loaded', true)
      })
    } else if (this.orderOptionSelected == 'Search By Style' && this.searchValue == '') {
      this.orders = []
      this.$emit('orders-loaded', true)
    }
  }

  methods.formatDate = function (date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  methods.goToOrder = function (item) {
    // this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
    this.pageLoading = true
    const postData = {
      item: item
    }
    console.log('getting rep orders')
    console.log(postData)
    axios.post(this.$apiAdress + '/api/orders/getPageByLogNumber?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      if (response.status === 200 || response.status === 201) {
        var route = this.$hostAddress + 'order/' + response.data.order_id + '/' + response.data.order_group_id
        window.open(route, '_blank')
      } else {
        Swal.fire({
          type: 'error',
          title: 'Sorry!',
          text: 'It looks like there is no log number in ace found with the record you tried.'
        })
      }
    })
  }
  
  methods.configureColor = function (item) {
    if (item) {
      var percent = ''
      switch(item.status) {
        case 'Entered': {
          percent = 'info'
          break
        }
        case 'Needs Entered': {
          percent = 'secondary'
          break
        }
        case 'Waiting On Customer': {
          percent = 'danger'
          break
        }
        case 'Received': {
          percent = 'info'
          break
        }
        case 'In Process': {
          percent = 'danger'
          break
        }
        case 'Shipped': {
          percent = 'success'
          break
        }
        case 'On Hold': {
          percent = 'warning'
          break
        }
        case 'Voided': {
          percent = 'warning'
          break
        }
        case 'Canceled': {
          percent = 'danger'
          break
        }
        default: {
          percent = ''
          break
        }
      }
      return percent
    } else {
      return 0
    }
  }
  
  methods.getCustomers = function () {
    let self = this
    // this.topLoading = true
    var repNum = ''
    
    const postData = {
      rep_number: this.$store.state.user.rep_number
    }
    axios.post( this.$apiAdress + '/api/getRepCustomers?token=' + localStorage.getItem("api_token"), postData)
    .then(function (response) {
  
  
      // self.customerOptions = response.data
      self.customerOptions = []
      response.data.forEach(function (val) {
        var obj = {}
        for (var key in val) {
          obj[key] = val[key]
        }
        obj.label = val.customer_name + ' - ' + val.customer_number
        self.customerOptions.push(obj)
      })
    }).catch(function (error) {
      // self.topLoading = false
    });
  }
  
  export default {
      // ===Component name
      name: "CustomerOrders",
      // ===Props passed to component
      props: ['customer_selected'],
      // ===Components used by this component
      components: {
        SearchOrders,
        OrderHistoryPdfViewer
      },
      // ====component Data properties
      data(){
          return{
            orders: null,
            fields: ['order_date', 'so_number', 'log_number', 'po_number', 'units', 'total_dollars', 'exp_ship_date', 'status', 'show'],
            // fields: ['check', 'as400_log_number', 'po_number', 'customer_name', 'order_items', 'ship_date', 'local_created_at', 'units', 'price', 'program_name', 'status','show'],
            filter: 'Last 15 Days',
            filterOptions: ['Last 15 Days', 'Last 30 Days', 'Last 60 Days', 'All'],
            orderOptionSelected: 'Open Orders',
            orderOptions: ['All Orders', 'Open Orders', 'POs Shipped'],
            loading: false,
            customerOptions: null,
            customerFilter: '',
            perPage: 15,
            currentPage: 1,
            totalItems: 0,
            downloadLoading: false,
            startDate: '',
            endDate: '',
            selected: [],
            showAll: false,
            pdfModal: false,
            pdfData: null,
            showPdfViewer: false,
            searchValue: ''
          }
      },
      watch: {
        'customerFilter': function (newVal, oldVal) {
          localStorage.setItem('customer_selected', JSON.stringify(this.customerFilter))
          this.getOrders()
          console.log('getting orders on customer filter change')
        },
        'filter': function (newVal, oldVal) {
          // this.getOrders()
          console.log('getting orders on filter change')
        }
        // 'startDate': function (newVal, oldVal) {
        //   if (oldVal) {
        //     this.getOrders()
        //   }
        // },
        // 'endDate': function (newVal, oldVal) {
        //   if (oldVal) {
        //     this.getOrders()
        //   }
        // }
      },
      // ===Code to be executed when Component is mounted
      mounted() {
        // this.getOrders()
        console.log('getting orders from mounted')
        // this.startDate = moment().subtract(1, 'months').format('YYYY-MM-DD')
        // this.endDate = moment().format('YYYY-MM-DD')
        // this.checkCustomer().then(res => {
        //   this.getOrders()
        //   this.getCustomers()
        // })
      },
      // ===Computed properties for the component
      computed: {},
      // ===Component methods
      methods: methods
  }
  </script>
  <!-- styles -->
  <!-- adding scoped attribute will apply the css to this component only -->
  <style scoped></style>
  